import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/* eslint-disable no-extra-boolean-cast */

import React from 'react';
import ReactDOMServer from 'react-dom/server';
export function isClassComponent(component) {
  return typeof component === 'function' && !!component.prototype.isReactComponent;
}
export function isFunctionComponent(component) {
  return typeof component === 'function' && String(component).includes('return React.createElement');
}
export function isComponentNull(component) {
  /* Renders a component and decides if the resulting rendered
   * HTML of the component is defined (not null)
   * */
  return !Boolean(ReactDOMServer.renderToStaticMarkup(component));
}
function isElement(element) {
  return /*#__PURE__*/React.isValidElement(element);
}
export function createComponentFromType(type, props) {
  return /*#__PURE__*/React.createElement(type, props);
}
export function createComponentFromFunction(func, props) {
  return func(props);
}
export function createComponent(typeOrFunc, props) {
  if (isClassComponent(typeOrFunc)) {
    return /*#__PURE__*/React.createElement(typeOrFunc, props);
  }
  if (isFunctionComponent(typeOrFunc)) {
    return createComponentFromFunction(typeOrFunc, props);
  }
  if (isElement(typeOrFunc)) {
    return /*#__PURE__*/React.cloneElement(typeOrFunc, _objectSpread(_objectSpread({}, typeOrFunc.props), props));
  }
  return createComponentFromType(typeOrFunc, props);
}